export enum MeasurableGroupType {
  GENERIC = 'generic',
  FUND = 'fund',
  INDEX = 'index',
  CLIENTS = 'clients',
  LOANS = 'loans',
  GRANT_RECIPIENTS = 'grants',
  WEIGHTED_PORTFOLIO = 'weighted-portfolio',
  WEIGHTED_PORTFOLIO_PRIVATE = 'private', // Private wealth management portfolio
  UNWEIGHTED_PORTFOLIO = 'unweighted-portfolio',
}

export const portfolioGroupTypes = [
  MeasurableGroupType.WEIGHTED_PORTFOLIO,
  MeasurableGroupType.UNWEIGHTED_PORTFOLIO,
  MeasurableGroupType.WEIGHTED_PORTFOLIO_PRIVATE,
];
